@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  height: 0;
  display: inline-block;
  position: fixed;
  right: 0;

  .fluid-sticky-button {
    position: relative;
    transform: rotate(-90deg);
    transform-origin: 100% 100%;
  }
}
